var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"add-btn",on:{"click":_vm.addText}},[_c('img',{attrs:{"src":require("../assets/add.png"),"alt":""}}),_vm._v(" Add Text ")]),_c('p',{staticClass:"title"},[_vm._v("Template")]),_c('div',{staticClass:"template-wrapper"},_vm._l((_vm.templates),function(item,index){return _c('div',{key:index,staticClass:"template",style:({
        fontFamily: item.fontFamily,
        color: item.color,
        fontSize: item.fontSize + 'px',
        lineHeight: item.lineHeight + 'px'
       }),on:{"click":function($event){return _vm.addTemplate(index)}}},[_vm._v(_vm._s(item.content))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }